import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

// Create Coupon API
export const createCoupon = async (businessId, payload) => {
  try {
    let resp = await http.post(`${URL}/coupon/${businessId}`, payload);
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
    
  }
};

// Get All Coupons API
export const getCoupons = async (businessId) => {
  try {
    let resp = await http.get(
      `${URL}/coupon/${businessId}`
    );
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};

// Get Single Coupon By Id
export const getOneCoupon = async (businessId, couponId) => {
  try {
    const result = await http.get(
      `${URL}/coupon/${businessId}/${couponId}`
    );
    return result;
  } catch (error) {
    console.log("error", error);
    errorHandler(error);
  }
};

// Delete Coupon API
export const deleteCoupon = async (businessId, couponId) => {
  try {
    const result = await http.delete(
      `${URL}/coupon/${businessId}/${couponId}`
    );
    return result;
  } catch (error) {
    console.log("error", error);
    return error;
  }
};
export const increaseCouponUsage = async (businessId, payload) => {
  try {
    const result = await http.post(
      `${URL}/coupon/${businessId}/increase-usage`,
      payload
    );
    return result;
  } catch (error) {
    console.error("error", error);
    errorHandler(error);
  }
};

// Update Coupon API
export const updateCoupon = async (businessId, couponId, data) => {
  try {
    const result = await http.put(
      `${URL}/coupon/${businessId}/${couponId}`,
      data
    );
    return result;
  } catch (error) {
    errorHandler(error);
  }
};

// Apply Coupon API
export const applyCoupon = async (businessId, payload) => {
  try {
    let resp = await http.post(`${URL}/coupon/${businessId}/apply`, payload);
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};